<template>

<core-content-wrapper>

</core-content-wrapper>

</template>

<script>

export default {

}

</script>

<style scoped>

</style>